import { practitionerTypes } from "../services/options/practitioner_types";
import { PractitionerType } from "../types/subscription/practitioner_type";

export function validatePractitionerType(practitionerType: PractitionerType) {
    return practitionerTypes.includes(practitionerType);
}
